<div class="image-container">
    <div class="image-preview">

    </div>
    <div class="params">
        <div>colortable</div>
        <div>number of drafts/color groups</div>
    </div>
</div>